import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetPassword } from "../../redux/actions/grievanceActions1";
import md5 from "md5";

const ResetPassword = ({ onClose, show, userDetails }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
console.log(userDetails)
  // Password states
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Show/hide password states
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Error state
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Validation function
  const validateForm = () => {
    const newErrors = {};

    // New Password validation
    if (!newPassword.trim()) {
      newErrors.newPassword = "New password is required";
    } 

    // Confirm Password validation
    if (!confirmPassword.trim()) {
      newErrors.confirmPassword = "Please confirm your password";
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleResetPassword = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const passwordData = {
        user_id: userDetails.USER_ID,
        new_password: md5(newPassword),
      };

      const res = await dispatch(resetPassword(passwordData));
      if (res.rCode === 0) {
        alert(res.rMessage || "Password reset successfully!");
        resetForm();
        onClose();
      } else {
        alert(res.rMessage || "Error resetting password!");
        resetForm();
        onClose();
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      alert("Error resetting password. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setNewPassword("");
    setConfirmPassword("");
    setShowNewPassword(false);
    setShowConfirmPassword(false);
    setErrors({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}
      tabIndex={-1}
      role="dialog"
      aria-labelledby="ResetPasswordModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div style={{ backgroundColor: "#fff" }} className="modal-content">
          <div className="modal-header">
            <h5
              className="modal-title font-size-16"
              id="resetPassword-exampleModalLabel"
            >
              <i className="bi bi-lock-fill me-2"></i>
              Reset Password
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="mb-3">
              <label htmlFor="new-password" className="form-label">
                New Password
              </label>
              <div className="position-relative">
                <input
                  type={showNewPassword ? "text" : "password"}
                  className={`form-control ${
                    errors.newPassword ? "is-invalid" : ""
                  }`}
                  id="new-password"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <button
                  className="btn btn-link position-absolute end-0 top-0 text-muted"
                  type="button"
                  style={{
                    border: "none",
                    background: "none",
                    padding: "12px",
                  }}
                  onClick={toggleNewPasswordVisibility}
                  aria-label={
                    showNewPassword ? "Hide password" : "Show password"
                  }
                >
                  <i
                    className={`bi ${
                      showNewPassword ? "bi-eye-slash" : "bi-eye"
                    }`}
                  ></i>
                </button>
                {errors.newPassword && (
                  <div className="invalid-feedback d-block">
                    {errors.newPassword}
                  </div>
                )}
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="confirm-password" className="form-label">
                Confirm Password
              </label>
              <div className="position-relative">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  className={`form-control ${
                    errors.confirmPassword ? "is-invalid" : ""
                  }`}
                  id="confirm-password"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <button
                  className="btn btn-link position-absolute end-0 top-0 text-muted"
                  type="button"
                  onClick={toggleConfirmPasswordVisibility}
                  aria-label={
                    showConfirmPassword ? "Hide password" : "Show password"
                  }
                >
                  <i
                    className={`bi ${
                      showConfirmPassword ? "bi-eye-slash" : "bi-eye"
                    }`}
                  ></i>
                </button>
                {errors.confirmPassword && (
                  <div className="invalid-feedback d-block">
                    {errors.confirmPassword}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn "
              style={{ background: "gray", color: "white" }}
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleResetPassword}
              className="modern-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Resetting...
                </>
              ) : (
                <>
                  <i className="bi bi-check-circle me-2"></i>
                  Reset Password
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
